import {
  ContactSchoolModal_school,
  ContactSchoolModal_user,
  RequestInfoModal_externalSchool,
  RequestInfoModal_user,
} from './gql'

export enum StepName {
  Confirmation = 'confirmation',
  Contact = 'contact',
  Login = 'login',
  SignUp = 'sign_up',
}

export interface IWithSchoolId {
  schoolId: number
  externalSchoolId?: undefined
}

export interface IWithExternalSchoolId {
  schoolId?: undefined
  externalSchoolId: number
}

export enum SchoolType {
  Internal = 'internal',
  External = 'external',
}

export type AuthenticatedUser = ContactSchoolModal_user | RequestInfoModal_user

interface ISchool {
  __type: SchoolType.Internal
  school: ContactSchoolModal_school
}

interface IExternalSchool {
  __type: SchoolType.External
  externalSchool: RequestInfoModal_externalSchool
}

export type SchoolContainer = ISchool | IExternalSchool

interface ISignUpStep {
  __stepname: StepName.SignUp
  schoolContainer: SchoolContainer
}

interface ILoginStep {
  __stepname: StepName.Login
  schoolContainer: SchoolContainer
}

interface IContactStep {
  __stepname: StepName.Contact
  schoolContainer: SchoolContainer
  user: AuthenticatedUser
}

interface IConfirmationStep {
  __stepname: StepName.Confirmation
  schoolContainer: SchoolContainer
  user: AuthenticatedUser
}

export type Step = ISignUpStep | ILoginStep | IContactStep | IConfirmationStep
